import { Typography, styled } from '../../../base';

export const StyledTitle = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.secondary,
}));
